export const alert = {
    state: {
        graphDataLoading: false,
        status: 'idle',
        alert: {}
    },
    mutations: {
        SET_GRAPH_DATA_STATUS(state, newStatus) {
            state.graphDataLoading = newStatus
        },
        SET_ALERT_STATUS(state, status) {
            state.status = status
        },
        SET_ALERT(state, alert) {
            state.alert = alert
        }
    },
    actions: {
        async fetchAlert({ state, commit }, payload) {
            commit('SET_ALERT', null)
            commit('SET_ALERT_STATUS', 'loading')

            try {
                const response = await this.$api.get(`api/alerts/${payload}.json`)
                commit('SET_ALERT', response.data.data)
                commit('SET_ALERT_STATUS', 'idle')
            } catch (error) {
                commit('SET_ALERT_STATUS', 'error')
                return Promise.reject(error)
            }
        },
        async fetchStats({ state, commit }, payload) {
            commit('SET_GRAPH_DATA_STATUS', true)

            if (!payload) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Brak danych do wykresu'
                })
                return
            }
            const params = {
                date_from: payload.dateFrom || undefined,
                date_to: payload.dateTo || undefined,
                status_id: payload.statusId || undefined,
                crop_id: payload.cropId || undefined,
                agrofag_id: payload.agrofagId || undefined
            }
            try {
                const response = await this.$api.get('api/alerts/stats', { params })
                return response.data
            } catch (error) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Nie można wczytać donych wykresu'
                })
                return error
            } finally {
                commit('SET_GRAPH_DATA_STATUS', false)
            }
        },
        async fetchAlertPrediction({ commit, state }, payload) {
            commit('SET_GRAPH_DATA_STATUS', false)
            if (!payload) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Brak danych wyszukania'
                })
                return
            }
            const params = {
                region: payload.region || undefined,
                disease: payload.disease || undefined,
                crop: payload.crop || undefined
            }
            try {
                const response = await this.$api.get('api/alerts/predictions', { params })

                return response
            } catch (error) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Nie można wczytać donych wykresu'
                })
            } finally {
                commit('SET_GRAPH_DATA_STATUS', false)
            }
        },
        async fetchCountieNameById({ commit, state }, payload) {
            try {
                const response = await this.$api.get('api/counties/alert-prediction-filters')

                const result = response.data.data.find(item => item.ogr_fid === payload)

                return result.mapped_name
            } catch (error) {
                return error
            }
        }
    },
    getters: {
        alertStatus: (state) => {
            return state.status
        },
        alert: (state) => {
            if (state.alert) {
                return state.alert
            }
        }
    }
}
